import React, { Component, Fragment } from "react";
import api from "../../../../services/api";

export default class ResumoMeta extends Component {

    constructor(props) {
        super(props);

        this.state = { 
            resumoMeta: {},
            id: ""
        }
    }

    async componentDidUpdate(prevProps, prevState) {
        if(prevProps.resumoMeta !== this.props.resumoMeta) {
            this.setState({ resumoMeta: this.props.resumoMeta });
        }
    }

    /*
    async componentDidMount() {
        let path = window.location.pathname;
        path = path.split("mensais-");
        path = path[path.length-1];
        await this.loadMetas(path);
    }

    loadMetas = async (id) => {
        let metas = await api.get(`/metas/${id}`);

        this.setState({
            resumoMeta: metas.data.metas
        });
    }
    */

    render() {
        let { curso, modalidade, tipo, turno, tipoMatricula, cargaHoraria, CR, fonte, comentario, unidade } = this.state.resumoMeta;
        return (
            <Fragment>
                {/* <div className="col-md-6 ml-auto mr-auto"> */}
                <div className="col-md-12">
                    <div className="card card-user">
                        <div className="card-header">
                            <div className="row">
                                <div className="col-md-12">
                                    <h3 className="text-uppercase m-2">Resumo</h3>
                                    <table className="mb-4 mt-4">
                                        <tbody>
                                            <tr>
                                                <td><p><strong>Unidade:</strong></p></td>
                                                <td>{unidade}</td>
                                            </tr>
                                            <tr>
                                                <td><p><strong>Curso:</strong></p></td>
                                                <td>{curso}</td>
                                            </tr>
                                            <tr>
                                                <td><p><strong>Modalidade:</strong></p></td>
                                                <td id="data-modalidade" data-modalidade={modalidade}>{modalidade}</td>
                                            </tr>
                                            <tr>
                                                <td><p><strong>Tipo:</strong></p></td>
                                                <td>{tipo}</td>
                                            </tr>
                                            {/* <tr>
                                                <td><p><strong>Turno:</strong></p></td>
                                                <td>{turno}</td>
                                            </tr> */}
                                            <tr>
                                                <td><p><strong>Tipo de Matrícula:</strong></p></td>
                                                <td>{tipoMatricula}</td>
                                            </tr>
                                            <tr>
                                                <td><p><strong>Carga Horária:</strong></p></td>
                                                <td>{cargaHoraria}</td>
                                            </tr>
                                            <tr>
                                                <td><p><strong>CR:</strong></p></td>
                                                <td>{CR}</td>
                                            </tr>
                                            <tr>
                                                <td><p><strong>Fonte:</strong></p></td>
                                                <td>{fonte}</td>
                                            </tr>
                                            <tr>
                                                <td><p><strong>Comentário:</strong></p></td>
                                                <td>{comentario}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}